import moment from 'moment';
import { format, fromUnixTime } from 'date-fns';
import { PrescriptionService } from '@/services/prescription.service';
import { formatPrescriptionDosage } from '@/utils/prescriptionDosage';
import { DoctorService } from '@/services/doctor.service';
import PrescriptionCard from '../infoview/PrescriptionCard.vue';
export default {
  components: {
    PrescriptionCard
  },
  props: {
    prescriptionData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      doctors: [],
      showDialog: false,
      selectedPrescription: {},
      prescriptionLogs: [],
      alert: {
        show: false,
        message: ''
      },
      loading: false,
      logFields: [{
        key: 'timestampcreated',
        label: 'Timestamp'
      }, {
        key: 'eventtype',
        label: 'Action'
      }, {
        key: 'user',
        label: 'User'
      }]
    };
  },
  watch: {
    async showDialog(show) {
      if (show) {
        const {
          data
        } = await DoctorService.getAllDoctors();
        this.doctors = data;
        if (!this.selectedPrescription) {
          this.selectedPrescription = this.prescriptionData[0];
        }
      } else {
        this.selectedPrescription = {};
      }
    },
    async selectedPrescription() {
      this.loading = true;
      this.alert.show = false;
      this.prescriptionLogs = [];
      const {
        data
      } = await PrescriptionService.getPrescriptionHistory(this.selectedPrescription.id);
      this.prescriptionLogs = data.sort((a, b) => {
        return a.timestampcreated - b.timestampcreated;
      });
      const stripeCancellation = this.prescriptionLogs.find(o => o.eventtype == 'Prescription Cancelled' && o.cancelledby == 'Stripe');
      if (stripeCancellation) {
        this.prescriptionLogs = this.prescriptionLogs.filter(o => {
          if (o.eventtype == 'Prescription Cancelled') {
            if (o.cancelledby != 'Stripe') {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        });
      }
      this.prescriptionLogs = this.prescriptionLogs.map(log => {
        var _log$eventtype;
        if ((_log$eventtype = log.eventtype) !== null && _log$eventtype !== void 0 && _log$eventtype.includes('Prescription Paused until')) {
          var _log$prescription;
          if (log !== null && log !== void 0 && (_log$prescription = log.prescription) !== null && _log$prescription !== void 0 && _log$prescription.resumecollection) {
            var _log$prescription2;
            return {
              ...log,
              eventtype: `Prescription Paused until ${this.parseUnixDate(log === null || log === void 0 ? void 0 : (_log$prescription2 = log.prescription) === null || _log$prescription2 === void 0 ? void 0 : _log$prescription2.resumecollection, 'yyyy-MM-dd')}`
            };
          }
        }
        return log;
      });
      if (this.prescriptionLogs.length == 0) {
        this.alert.message = 'This prescription has no logs.';
        this.alert.show = true;
      }
      this.loading = false;
    }
  },
  methods: {
    formatDosage(medicinename, dosage) {
      return formatPrescriptionDosage(medicinename, dosage);
    },
    formatDate(date, format) {
      if (!date) {
        return '-';
      } else {
        return moment(date).format(format);
      }
    },
    parseUnixDate(date, formatString) {
      return format(fromUnixTime(date), formatString);
    },
    openPrescriptionLog(prescription) {
      this.selectedPrescription = prescription;
    },
    formatLogTime(timestamp) {
      return moment(timestamp * 1000).format('MM/DD/YYYY LT');
    },
    getDoctorName(id) {
      const doctor = this.doctors.find(o => o.id == id);
      if (doctor !== null && doctor !== void 0 && doctor.firstname && doctor !== null && doctor !== void 0 && doctor.lastname) {
        return `Dr. ${doctor.firstname} ${doctor.lastname}`;
      }
    },
    getUserValue(row) {
      var _row$eventtype, _row$eventtype2;
      const doctorEvents = ['Prescription Updated', 'Prescription Re-Ordered'];
      if (row.eventtype == 'Prescription Created') {
        return this.getDoctorName(row.doctorid);
      } else if (row.eventtype == 'Prescription Cancelled' || row.eventtype == 'Prescription Canceled' || row.eventtype == 'Prescription Completed') {
        if (row.cancelledbyrole == 'ADMIN') {
          return row.cancelledby;
        } else if (row.cancelledbyrole == 'DOCTOR') {
          return `Dr. ${row.cancelledby}`;
        } else if (row.role == 'ADMIN') {
          return row.actionby;
        } else {
          if (!row.cancelledby) {
            if (row.actionby) {
              return row.actionby;
            }
          } else {
            return row.cancelledby;
          }
        }
      } else if (doctorEvents.includes(row.eventtype)) {
        return this.getDoctorName(row.doctorid);
      } else if ((_row$eventtype = row.eventtype) !== null && _row$eventtype !== void 0 && _row$eventtype.startsWith('Prescription Scheduled')) {
        return this.getDoctorName(row.doctorid);
      } else if ((_row$eventtype2 = row.eventtype) !== null && _row$eventtype2 !== void 0 && _row$eventtype2.startsWith('Prescription Paused') && row.role == 'PATIENT') {
        return row.role;
      } else {
        if (row.role == 'DOCTOR') {
          return `Dr. ${row.actionby}`;
        } else {
          return row.actionby;
        }
      }
    }
  }
};